
import homePageData from "../../data/homePage";
import cdnPageData from "../../data/cdn";
import Calculator from "../../components/vps/calculator.vue";
import Customers from "../../components/vps/customers.vue";
import Os from "../../components/vps/os.vue";
import Benefits from "../../components/vps/benefits.vue";
import Modal from "../../components/rebranding/modal/Modal.vue";
import Uses from "../../components/vps/uses.vue";
import Plans from "../../components/cdn/plans.vue";

export default {
  components: {
    Calculator,
    Os,
    Customers,
    Plans,
    Benefits,
    Modal,
    Uses,
    Plans,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "خرید CDN ایرانی | شبکه توزیع محتوا آبالون",
      meta: [
        {
          name: "description",
          content:
            "با سرویس CDN ایرانی آبالون، محتوای وب‌سایت سازمانی خود را سریع‌تر و امن‌تر به کاربران برسانید | شبکه توزیع محتوا با پاپ‌سایت‌های فعال در ۵ قاره جهان",
        },
        {
          name: "keywords",
          content: "سرویس CDN, CDN آبالون, CDN ایرانی",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/cdn",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "خرید CDN ایرانی | شبکه توزیع محتوا آبالون",
        },
        {
          property: "og:description",
          content:
            "با سرویس CDN ایرانی آبالون، محتوای وب‌سایت سازمانی خود را سریع‌تر و امن‌تر به کاربران برسانید | شبکه توزیع محتوا با پاپ‌سایت‌های فعال در ۵ قاره جهان",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/cdn",
        },
        {
          name: "twitter:title",
          title: "خرید CDN ایرانی | شبکه توزیع محتوا آبالون",
        },
        {
          name: "twitter:description",
          content:
            "با سرویس CDN ایرانی آبالون، محتوای وب‌سایت سازمانی خود را سریع‌تر و امن‌تر به کاربران برسانید | شبکه توزیع محتوا با پاپ‌سایت‌های فعال در ۵ قاره جهان",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/cdn",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "خرید CDN ایرانی آبالون چه مزیتی نسبت به CDN های خارجی دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سرویس CDN آبالون با بیش از ۴۰ پاپ‌سایت ایرانی و بین‌المللی، زیرساخت توزیع محتوای گسترده‌ای در داخل ایران فراهم کرده است. خرید CDN آبالون، باعث کاهش چشمگیر تأخیر برای کاربران داخل کشور و ارائه تجربه‌ای سریع‌تر و پایدارتر نسبت به سرویس‌های خارجی فاقد پاپ‌سایت داخلی می‌شود.",
                },
              },
              {
                "@type": "Question",
                name: "آیا سرویس CDN آبالون باعث افزایش امنیت وب‌سایت من می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. آبالون با بهره‌گیری از لایه‌های امنیتی مختلف مانند WAF، فایروال، چالش‌های امنیتی لایه ۷، محدودسازی نرخ درخواست‌ها و مقابله با حملات DDoS در لایه‌های مختلف، امنیت وب‌سایت یا اپلیکیشن شما را به‌صورت جامع و یکپارچه تأمین می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا در سرویس CDN آبالون می‌توان بار را میان چند سرور توزیع کرد و این کار پیچیدگی خاصی دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. با استفاده از لود بالانسرهای DNS و HTTP آبالون، می‌توانید بدون نیاز به زیرساخت اختصاصی و تنظیمات پیچیده، ترافیک را به‌صورت پیشرفته مدیریت و میان چند سرور توزیع کنید. این ابزارها با رابط کاربری ساده، امکان راه‌اندازی سریع و پایدار را فراهم می‌کنند.",
                },
              },
              {
                "@type": "Question",
                name: "گواهینامه SSL در CDN آبالون چگونه فعال می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CDN آبالون برای تمام دامنه‌های متصل، به‌صورت خودکار گواهینامه SSL رایگان صادر و فعال می‌کند. این فرآیند بدون نیاز به مداخله شما انجام شده و ارتباط امن HTTPS را برای کاربران نهایی تضمین می‌کند. البته در صورت تمایل، می‌توانید گواهینامه SSL اختصاصی خود را نیز بارگذاری و استفاده کنید.",
                },
              },
              {
                "@type": "Question",
                name: "برای انتخاب بهترین CDN ایرانی چه فاکتورهایی باید مدنظر گرفت؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "در انتخاب یک CDN ایرانی قدرتمند، فاکتورهایی مانند وجود پاپ‌سایت‌های توزیع‌شده در داخل کشور و نقاط کلیدی جهان، امکانات امنیتی پیشرفته نظیر WAF، فایروال و جلوگیری از حملات DDoS، و همچنین قابلیت لود بالانسینگ برای مدیریت بهینه ترافیک اهمیت دارد. در کنار این ویژگی‌های فنی، یک CDN حرفه‌ای باید رابط کاربری ساده و در عین حال امکان پیکربندی پیشرفته را نیز در اختیار کاربران قرار دهد. CDN ایرانی آبالون با ترکیب این قابلیت‌ها، یکی از گزینه‌های برتر برای سازمان‌ها و کسب‌وکارهای ایرانی است.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "CDN ابری آبالون",
            },
            author: {
              "@type": "Person",
              name: "Hamid Karimi",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      tabItems: cdnPageData.tabItems,
      solotionTabItems: cdnPageData.solotionTabItems,
      benefits: homePageData.benefits,
      dataBlog: homePageData.dataBlog,
      questions: cdnPageData.questions,
      PopularServices: cdnPageData.PopularServices,
      serviceFeatures: cdnPageData.serviceFeatures,
      scrubbingCenter: cdnPageData.scrubbingCenter,
      cdnCoverage: cdnPageData.cdnCoverage,
      uses: homePageData.uses,
      locations: homePageData.locations,
      activeSection: "",
      tab: 0,
      solotionTab: 0,
      showmore: false,
    };
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
    showMore() {
      this.showmore = true;
    },
  },
};
